import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MyFeedbackLawyerConsultationPage from './pages/MyFeedbackLawyerConsultationPage';
import MyFeedbackLawyerConsultationDetailPage from './pages/MyFeedbackLawyerConsultationDetailPage';

const MyFeedbackLawyerConsultationModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MyFeedbackLawyerConsultationPage />} />
      <Route path="/:applicationId" element={<MyFeedbackLawyerConsultationDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MyFeedbackLawyerConsultationModule;
